import { useEffect } from 'react';
import ConfigState from '../../config/state/config-state';
import { setLocale } from '../services/i18n';

const useI18n = (config: ConfigState) => {
  useEffect(() => {
    if (config.type === 'themed') {
      setLocale(config.config.data.language, config.config.i18n).then();
    }
  }, [config.type]);
};

export default useI18n;
